<app-navbar></app-navbar>
<div  id="outage">
    <div *ngIf="outagebol" class="container" id="form">
      <div class="title">IDAY Profile Update</div>
      <div class="content">
        <form action="#" (submit)="preview($event)" >
          <div class="user-details">
            <div class="input-box">
              <span class="details">First Name</span>
              <input type="text" placeholder="Enter the First Name" required id="outage-form" [(ngModel)]="outageinputval.firstname" name="outage" />
            </div>
            <div class="input-box">
              <span class="details">Last Name</span>
              <input type="text" placeholder="Enter the Last Name" required id="what" [(ngModel)]="outageinputval.lastname" name="what" />
            </div>
            <div class="input-box">
              <span class="details">Email Account</span>
              <select id="environment" name="Environment" [(ngModel)]="outageinputval.emailaccount" (change)="email()" name="environment">
                <option value="CEO" >CEO</option>
                <option value="CFO">CFO</option>
                <option value="CPD">CPD</option>
                <option value="CMO">CMO</option>
                <option value="CHRO">CHRO</option>
                <option value="CSO">CSO</option>
                <option value="CIO">CIO</option>
                <option value="CQA">CQA</option>
                <option value="vinutha.naik">vinutha.naik</option>
                <option value="benedict.alphonse">benedict.alphonse</option>
                <option value="Others">Others</option>
              </select>
            </div>
            <div class="input-box">
              <span class="details">Enterprise Name</span>
              <input type="text" placeholder="Enterprise Name" required id="when" [(ngModel)]="outageinputval.enterprisename" name="when" />
            </div>
            <!-- <div class="input-box"> -->
              <!-- <span class="details">Admin Email</span>
              <input type="text" placeholder="Admin Email" required id="nextUpdate" [(ngModel)]="outageinputval.adminemail" name="nextupdate" />
            </div>
            <div class="input-box">
              <span class="details">Admin Password</span>
              <input type="text" placeholder="Admin Password" required id="impact" [(ngModel)]="outageinputval.adminpassword" name="impact" />
            </div> -->
            <div class="input-box">
              <span class="details">Email Address</span>
              <input type="text" placeholder="Master Emal" required id="email" [(ngModel)]="emails" name="emailadress" value={{emails}} />
            </div>
            <div class="input-box ">
                <span class="details">Upload Profile Image</span>
                <input (change)="onFileChanged1($event)" class="image" type="file" value="Profile Image" id="submit-ei" />
              </div>
              <!-- <div class="input-box">
                    <span class="details">Upload Enterprise Image</span>
                <input (change)="onFileChanged2($event)" class="image" type="file" value="Enterprise Image" id="submit-ei" />
              </div> -->
          </div>
          <div class="button">
            <input type="submit" value="Preview" id="submit" />
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="previewbol" class="container" id="preview">
      <h3>First Name</h3>
      <p id="outage-preview">{{outageinputval.firstname}}</p>

      <h3>Last Name</h3>
      <p id="what-preview">{{outageinputval.lastname}}</p>

      <h3>Email Account</h3>
      <p id="env-preview">{{outageinputval.emailaccount}}</p>

      <h3>Email Address</h3>
      <p id="env-preview">{{emails}}</p>

      <h3>Enterprise</h3>
      <p id="when-preview">{{outageinputval.enterprisename}}</p>

      <!-- <h3>Admin Email</h3>
      <p id="next-update-preview">{{outageinputval.adminemail}}</p>

      <h3>Admin Password</h3>
      <p id="impact-preview">{{outageinputval.adminpassword}}</p> -->

      <h3>Profile IMage</h3>
      <img class="images" src="{{previewImage1}}" alt="">

      <!-- <h3>Enterprise Image</h3>
      <img class="images" src="{{previewImage2}}" alt=""> -->


      <form action="#" (submit)="sendemail()">
        <div class="button">
          <input (click)="goback()" type="submit" value="Go Back" id="back" />
        </div>
        <div *ngIf="!loading"  class="button" >

          <input type="submit" value="Update Profile" id="send-email" />
        </div>
        <div *ngIf="!loading" class="button" >
          <input type="button" id="send-email" value = "Purge Profile" (click)="onnclickpurge()"/>
        </div>
        <div *ngIf="loading" class="loadingbtn">
          <button class="btn btn-primary button" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Updating Profile...
          </button>
        </div>
        <div id="outage-response" *ngIf="statusAvailable">
          <span>Status</span>
          {{returndata}}
          <span>{{responseMessage}}</span>
        </div>
      </form>
    </div>
  </div>
